export const APP_LOAD = 'APP_LOAD'
export const ASYNC_START = 'ASYNC_START'
export const ASYNC_END = 'ASYNC_END'
export const LOAD_PRICE = 'LOAD_PRICE'
export const LOAD_DATA = 'LOAD_DATA'
export const SAVE_PHONE_EMAIL = 'SAVE_PHONE_EMAIL'
export const APP_SAVE_ORDER = 'APP_SAVE_ORDER'
export const APP_LOAD_ORDER = 'APP_LOAD_ORDER'
